import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { baseService } from './base.service'
import { IBaseService } from './interfaces/base-service.interface'

import { QueryParams } from '@/types/base.type'
import { EmojiType } from '@/types/emoji.type'
import { ListResponse } from '@/types/list.type'

export class EmojiService {
  private static instance: EmojiService
  private readonly api: AxiosInstance

  constructor(private readonly baseService: IBaseService) {
    this.api = this.baseService.getClient()
  }

  public static getInstance(baseService: IBaseService): EmojiService {
    if (!EmojiService.instance) {
      EmojiService.instance = new EmojiService(baseService)
    }
    return EmojiService.instance
  }

  getEmojis = async (
    {
      queryParams,
    }: {
      queryParams: QueryParams
    },
    configs?: AxiosRequestConfig
  ) => {
    const { pageNumber, pageSize, sort, search, searchFields } = queryParams
    let url = '/emoji'

    if (pageNumber && pageSize) {
      url += `?pageNumber=${pageNumber}&pageSize=${pageSize}`
    }
    if (sort) {
      url += pageNumber && pageSize ? `&sort=${sort}` : `?sort=${sort}`
    }
    if (search) {
      url += url.includes('?') ? `&search=${search}` : `?search=${search}`
    }
    if (searchFields) {
      url += url.includes('?') ? `&searchFields=${searchFields.join(',')}` : `?searchFields=${searchFields.join(',')}`
    }
    const { data } = await this.api.get<ListResponse<EmojiType>>(url, configs)
    return data
  }

  createEmoji = async ({ name, image }: { name: string; image: File }, options?: AxiosRequestConfig) => {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('image', image)

    const { data } = await this.api.post<EmojiType>('/emoji', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...options,
    })
    return data
  }

  getEmojiById = async (id: number, options?: AxiosRequestConfig) => {
    const { data } = await this.api.get<EmojiType>(`/emoji/${id}`, options)
    return data
  }

  deleteEmoji = async (id: number, options?: AxiosRequestConfig) => {
    const { data } = await this.api.delete(`/emoji/${id}`, options)
    return data
  }

  updateEmoji = async (id: number, { name, image }: { name?: string; image?: File }, options?: AxiosRequestConfig) => {
    const formData = new FormData()
    if (name) {
      formData.append('name', name)
    }
    if (image) {
      formData.append('image', image)
    }

    const { data } = await this.api.put<EmojiType>(`/emoji/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...options,
    })
    return data
  }
}

const emojiService = EmojiService.getInstance(baseService)

export default emojiService
